export default {
  defaultAvatar:
    'https://storage.googleapis.com/buildtoriot-cdn/not-logged-avatar.jpg',
  defaultCover:
    'https://storage.googleapis.com/buildtoriot-cdn/header-background.jpeg',
  defaultLogo:
    'https://storage.googleapis.com/buildtoriot-cdn/header-background.jpeg',
}
